import {
  CONTEXT_BAR_HEIGHT,
  TIMELINE_AGE_VIEW_HEIGHT,
  TIMELINE_GROUP_HEADER_HEIGHT,
  TIMELINE_GROUP_TOP_PADDING,
  TIMELINE_HEADER_HEIGHT,
  TIMELINE_HIDE_ITEM_CARD_MARKER_LABEL_MARGIN_LEFT,
  TIMELINE_MOBILE_HEADER_HEIGHT
} from "../..";

export default {
  // Regular Header
  HEADER_HEIGHT: TIMELINE_HEADER_HEIGHT,
  MAJOR_TICK_PADDING_LEFT: 5,
  MAJOR_TICK_PADDING_TOP: 14,
  MINOR_TICK_PADDING_TOP: 32,
  MINOR_TICK_DOT_MARGIN_TOP: 4,
  // Thin Mobile Header
  MOBILE_HEADER_HEIGHT: TIMELINE_MOBILE_HEADER_HEIGHT,
  MOBILE_MAJOR_TICK_PADDING_TOP: 0,
  MOBILE_MINOR_TICK_PADDING_TOP: 16,
  MOBILE_MINOR_TICK_DOT_MARGIN_TOP: 4,
  // Other Parts
  AGE_HEIGHT: TIMELINE_AGE_VIEW_HEIGHT,
  MARKER_HEIGHT: 13,
  MARKER_HEIGHT_NO_CARD: 19,
  PARENT_SHADOW_OFFSET: 5,
  CONTEXT_BAR_HEIGHT: CONTEXT_BAR_HEIGHT,
  CONTEXT_DOT_SIZE: 6,
  TIMELINE_BOTTOM_PADDING: 100,
  GROUP_HEADER_HEIGHT: TIMELINE_GROUP_HEADER_HEIGHT,
  GROUP_TOP_PADDING: TIMELINE_GROUP_TOP_PADDING,
  HIDE_ITEM_CARD_MARKER_LABEL_MARGIN_LEFT: TIMELINE_HIDE_ITEM_CARD_MARKER_LABEL_MARGIN_LEFT
};
